var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',[_c('date-picker',{attrs:{"valueType":"format","placeholder":"Select Date"},on:{"input":_vm.selectDate},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }